export default __webpack_public_path__ + "static/media/person-placeholder.d5d11297.svg";